import React, { memo } from 'react'

import { Icon, CalendarToday } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'
import I18n from 'Pods/Shared/I18n'

const translate = (key) => I18n.t(key, { ns: 'rails' })

const prefixIcon = <Icon notSpaced svgComponent={CalendarToday} color="dark" size="small" />

function DatePublished() {
  // Placeholder dropdown; its contents are defined in a follow-up subtask.
  const content = (
    <div className="main-filters__dropdown-placeholder cgt-body-base">
      {translate('search_page.filters.under_construction')}
    </div>
  )

  return (
    <FiltersWrapper
      placeholder={translate('search_page.filters.date_published.title')}
      prefixIcon={prefixIcon}
      content={content}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(DatePublished)
